import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { TablePayments } from "./TablePayments/TablePayments";
import { PlanActive } from "./PlanActive/Index";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { CardCredit } from "./CardCredit/Index";
import { Faq } from "../Faq/Faq";

export const PageSubscriptions = () => {
  const { openAside, handleOpenModalSubscriptions } = useLayoutMainContext();
  const { userPerfil } = useAuthContext();

  const theme = useTheme();

  const isBreakPoint = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <>
      {userPerfil?.email === "richard_madrigar99@hotmail.com" && (
        <ButtonCore
          title="Abrir planos"
          onClick={handleOpenModalSubscriptions}
          sx={{ mt: 2 }}
        />
      )}

      <Grid container spacing={3} mb={4} mt={1}>
        <Grid item xs={12} md={openAside && isBreakPoint ? 12 : 6}>
          <PlanActive />
        </Grid>

        <Grid item xs={12} md={openAside && isBreakPoint ? 12 : 6}>
          <CardCredit />
        </Grid>
      </Grid>

      <Box mb={8}>
        <TablePayments />
      </Box>

      <Faq />
    </>
  );
};
